import styled from 'styled-components';

export const SlideContainer = styled.div`
  width: 100%;
  position: relative;
  height: calc(100dvh - 48px);
`;

export const BottomButtonContainer = styled.div`
  width: 100%;
  max-width: 768px;
  padding: 15px 24px;
  background-color: white;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  position: absolute;
  bottom: 0px;
`;

export const SkipText = styled.div`
  padding: 4px 10px;

  display: flex;
  gap: 6px;
  align-items: center;

  svg {
    width: 7px;
    path {
      stroke: ${({ theme }) => theme['font-tertiary']};
    }
  }
`;

export const TermsSlide = styled.div`
  width: 100%;
  padding: 20px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 28px;
`;

export const InputLength = styled.div`
  position: absolute;
  right: 12px;
`;

export const Text = styled.div`
  padding: 0px 10px;
`;
